import {SchemaDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';

import itemTableDefinition from '../tables/item';
import propertyTableDefinition from '../tables/property';
import propertyResolvedTableDefinition from '../tables/propertyResolved';
import referenceTableDefinition from '../tables/reference';
import referencePropertyTableDefinition from '../tables/referenceProperty';
import fileTableDefinition from '../tables/file';
import itemTypeTableDefinition from '../tables/itemType';
import propertyTypeTableDefinition from '../tables/propertyType';
import propertySetTableDefinition from '../tables/propertySet';
import referenceTypeTableDefinition from '../tables/referenceType';
import referenceSetTableDefinition from '../tables/referenceSet';
import referencePropertySetTableDefinition from '../tables/referencePropertySet';
import statusTableDefinition from '../tables/status';
import valueTableDefinition from '../tables/value';
import valueSetTableDefinition from '../tables/valueSet';


const schemaDefinition : SchemaDefinition = {
    tables: {
        item             : Object.assign(
            {},
            itemTableDefinition,
            {
                hasHistorySnapshot          : true,
                hasPlannedView              : true,
                hasTemplateView             : true,
                hasImportedView             : true,
                hasActivePlannedView        : true,
                hasActivePlannedTemplateView: true
            }
        ),
        property         : Object.assign(
            {},
            propertyTableDefinition,
            {
                hasHistorySnapshot          : true,
                hasPlannedView              : true,
                hasTemplateView             : true,
                hasImportedView             : true,
                hasActivePlannedView        : true,
                hasActivePlannedTemplateView: true
            }
        ),
        propertyResolved : Object.assign(
            {},
            propertyResolvedTableDefinition,
            {
                hasHistorySnapshot          : false,
                hasPlannedView              : true,
                hasTemplateView             : true,
                hasImportedView             : true,
                hasActivePlannedView        : true,
                hasActivePlannedTemplateView: true
            }
        ),
        reference        : Object.assign(
            {},
            referenceTableDefinition,
            {
                hasHistorySnapshot          : true,
                hasPlannedView              : true,
                hasTemplateView             : true,
                hasImportedView             : true,
                hasActivePlannedView        : true,
                hasActivePlannedTemplateView: true
            }
        ),
        referenceProperty: Object.assign(
            {},
            referencePropertyTableDefinition,
            {
                hasHistorySnapshot          : true,
                hasPlannedView              : true,
                hasTemplateView             : true,
                hasImportedView             : true,
                hasActivePlannedView        : true,
                hasActivePlannedTemplateView: true
            }
        ),

        file: {
            ...fileTableDefinition
        },

        itemType            : Object.assign(
            {},
            itemTypeTableDefinition,
            {
                hasView           : false,
                hasHistorySnapshot: true
            }
        ),
        propertyType        : Object.assign(
            {},
            propertyTypeTableDefinition,
            {
                hasView           : false,
                hasHistorySnapshot: true
            }
        ),
        propertySet         : Object.assign(
            {},
            propertySetTableDefinition,
            {
                hasView           : false,
                hasHistorySnapshot: true
            }
        ),
        referenceType       : Object.assign(
            {},
            referenceTypeTableDefinition,
            {
                hasView           : false,
                hasHistorySnapshot: true
            }
        ),
        referenceSet        : Object.assign(
            {},
            referenceSetTableDefinition,
            {
                hasView           : false,
                hasHistorySnapshot: true
            }
        ),
        referencePropertySet: Object.assign(
            {},
            referencePropertySetTableDefinition,
            {
                hasView           : false,
                hasHistorySnapshot: true
            }
        ),
        status              : Object.assign(
            {},
            statusTableDefinition,
            {
                hasView       : false,
                hasActiveView : false,
                hasHistoryView: false
            }
        ),
        value               : Object.assign(
            {},
            valueTableDefinition,
            {
                hasHistorySnapshot: true
            }
        ),
        valueSet            : Object.assign(
            {},
            valueSetTableDefinition,
            {
                hasView           : false,
                hasHistorySnapshot: true
            }
        )
    }
};

export default schemaDefinition;
